import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { LogInterceptor } from '../interceptors/log.interceptor';

export interface Options<T> {
  [key: string]: T;
}

export type Environment = Options<any> & {
  production:   boolean;
  version:      string;
  BASE_API_URL: string;
  report:       boolean;
  name:         string;
  imageName:    string;
  passSteps:    boolean;
  freight:      boolean;
};

export const ENVIRONMENT_TOKEN = new InjectionToken<Environment>('environment');

export const getLogInterceptorEnvironment = (environment: Environment) => {
  return [
    { provide: HTTP_INTERCEPTORS, useClass: LogInterceptor, multi: true },
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
  ];
};
